import * as React from "react";
import {Alert, Button, Card, Col, Form, notification, Row, Tabs} from "antd";
import {FormComponentProps} from "antd/lib/form";
import {ProjectItem, ProjectStore} from "src/stores/projects-store";
import {connect} from "redux-scaffolding-ts";
import autobind from "autobind-decorator";
import {ProjectFormBody} from "src/pages/admin/projects/project-change";
import {clone} from "src/core/utils/object";
import FormEditorView from "src/core/ui/form/form-editor";
import {withTranslation, WithTranslation} from 'react-i18next'
import {RouteComponentProps, withRouter} from 'react-router-dom'
import ContentTitle from 'src/core/ui/content-header';
import {formatMessage} from "../../../core/services/http.service";
import ProjectsTasksList from 'src/pages/admin/projects/tasks/projecttask-list';
import ProjectsMembersList from 'src/pages/admin/projects/members/projectmember-list';
import ProjectsTasksAssignmentsList from 'src/pages/admin/projects/assignments/projecttaskassignment-list';
import {withIdentity} from "../../../core/services/authentication";
import moment from "moment-timezone";
import {CacheProps, withCache} from '../../../core/services/cache.service';
import {isNullOrUndefined} from "util";
import {UserProfileProps, withUserProfile} from "../../../components/user-profile";


interface ProjectViewProps extends RouteComponentProps<{ projectId: string, companyId: string }>, UserProfileProps , CacheProps {
    onClose: (id: string | undefined, item?: ProjectItem) => void;
}

interface ProjectViewState {
    activeKey: string;
    shouldRefreshAssignments: boolean;
    shouldRefreshTasks: boolean;
}

@connect(["project", ProjectStore])
class ProjectView extends React.Component<ProjectViewProps & WithTranslation & FormComponentProps, ProjectViewState> {
    private get projectsStore() {
        return (this.props as any).project as ProjectStore;
    }

    constructor(props: ProjectViewProps & WithTranslation & FormComponentProps) {
        super(props);
        this.projectsStore.clear();
        this.projectsStore.changeUrl(props.match.params.companyId);
        this.state = {
            activeKey: this.props.cache.get() ??  "general",
            shouldRefreshAssignments: false,
            shouldRefreshTasks:false,
        }
    }

    componentWillMount(): void {
        if (!this.checkAuth())
            this.props.history.push('/');
        this.load();
    }

    componentWillUpdate() {
        if (!this.checkAuth())
            this.props.history.push('/');
    }

    @autobind
    private checkAuth() {
        return this.props.userProfile && this.props.userProfile.roles &&
            (this.props.userProfile.roles.includes("Manager")
                || this.props.userProfile.roles.includes("Administrator")
                || this.props.userProfile.roles.includes("ClientAdmin")
                || this.props.userProfile.roles.includes("FIConsultant")
                || this.props.userProfile.roles.includes("CompanyDataViewer"));
    }

    @autobind
    private isReadOnly() {
        return (this.props.userProfile && this.props.userProfile.roles &&
            (this.props.userProfile.roles.includes("CompanyDataViewer")
                && !(this.props.userProfile.roles.includes("Manager")
                    || this.props.userProfile.roles.includes("Administrator")
                    || this.props.userProfile.roles.includes("ClientAdmin")
                    || this.props.userProfile.roles.includes("FIConsultant"))));
    }

    @autobind
    private load() {
        return this.projectsStore.getById(this.props.match.params.projectId, undefined, this.props.match.params.companyId);
    }

    @autobind
    private async onChangeTab(activeKey: string) {
        this.props.history.push(`/time-tracking/admin/companies/${this.props.match.params.companyId}/?tab=${activeKey}`);
    }

    private isTabAvilable(tab: string | null): boolean {
        return !isNullOrUndefined(tab) && ['general', 'members', 'tasks', 'assignments'].includes(tab);
    }

    @autobind
    private countDownNotification(_notification: any, message: string, description: string, key: string) {
        let secondsToGo = 4;
        _notification({
            key: key,
            message: message + `(${secondsToGo}).`,
            description: description
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            _notification({
                key: key,
                message: message + `(${secondsToGo}).`,
                description: description,
                onClose: () => clearInterval(timer),
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            notification.close(key);
        }, secondsToGo * 1000);
    }

    @autobind
    private async handleUpdateItem(values: any) {
        const { t } = this.props;
        var fromDate: number = moment().utc().startOf("day").unix()
        var toDate: number | null = null

        if (values.fromDate) {
            fromDate = values.fromDate.unix()
        }
        if (values.toDate) {
            toDate = values.toDate.unix()
        }

        let unzipedValues = { ...values, fromDate: fromDate, toDate: toDate }
        var update = await this.projectsStore.update(Object.assign(clone(this.projectsStore.state.item), unzipedValues), this.props.match.params.companyId).then(() => this.countDownNotification(notification.success, t("Notification"), t("All changes were successfully saved"), "succes")).catch(error => { this.countDownNotification(notification.error, t("Error"), t("There was an error saving changes"), "error") }) //eturn this.projectsStore.update(Object.assign(clone(this.projectsStore.state.item), unzipedValues)).then(() => this.countDownNotification(notification.success, t("Notification"), t("All changes were successfully saved"), "succes")).catch(error => { this.countDownNotification(notification.error, t("Error"), t("There was an error saving changes"), "error") });
        this.setState({ shouldRefreshTasks: true })
        return update
    }

    @autobind
    private onChange(activeKey: string) {
        if (activeKey === 'assignments') {
            this.setState({ shouldRefreshAssignments: true });
        } else {
            this.setState({ shouldRefreshAssignments: false });
        }
        this.props.history.push(`/time-tracking/admin/companies/${this.props.match.params.companyId}/projects/${this.props.match.params.projectId}/?tab=${activeKey}`, {
            titles: [...(this.props.location.state ? (this.props.location.state as any).titles || [] : [])],
        });
        this.setState({ activeKey: activeKey })
        this.props.cache.save(activeKey);
    }

    @autobind
    private onClickLeftArrow() {
        switch (this.state.activeKey) {
            case "general": {
                this.setState({ activeKey: "assignments" })
                this.props.history.push(`/time-tracking/admin/companies/${this.props.match.params.companyId}/projects/${this.props.match.params.projectId}/?tab=assignments`);
                break
            }
            case "members": {
                this.setState({ activeKey: "general" })
                this.props.history.push(`/time-tracking/admin/companies/${this.props.match.params.companyId}/projects/${this.props.match.params.projectId}/?tab=general`);
                break
            }
            case "tasks": {
                this.setState({ activeKey: "members" })
                this.props.history.push(`/time-tracking/admin/companies/${this.props.match.params.companyId}/projects/${this.props.match.params.projectId}/?tab=members`);
                break
            }
            case "assignments": {
                this.setState({ activeKey: "tasks" })
                this.props.history.push(`/time-tracking/admin/companies/${this.props.match.params.companyId}/projects/${this.props.match.params.projectId}/?tab=tasks`);
                break
            }
        }

    }

    @autobind
    private onClickRighttArrow() {
        switch (this.state.activeKey) {
            case "general": {
                this.setState({ activeKey: "members" })
                this.props.history.push(`/time-tracking/admin/companies/${this.props.match.params.companyId}/projects/${this.props.match.params.projectId}/?tab=members`);
                break
            }
            case "members": {
                this.setState({ activeKey: "tasks" })
                this.props.history.push(`/time-tracking/admin/companies/${this.props.match.params.companyId}/projects/${this.props.match.params.projectId}/?tab=tasks`);
                break
            }
            case "tasks": {
                this.setState({ activeKey: "assignments" })
                this.props.history.push(`/time-tracking/admin/companies/${this.props.match.params.companyId}/projects/${this.props.match.params.projectId}/?tab=assignments`);
                break
            }
            case "assignments": {
                this.setState({ activeKey: "general" })
                this.props.history.push(`/time-tracking/admin/companies/${this.props.match.params.companyId}/projects/${this.props.match.params.projectId}/?tab=general`);
                break
            }
        }
    }

    public render() {
        let isReadOnly = this.isReadOnly()
        const { t } = this.props;
        const search = this.props.location.search;
        const tabId = new URLSearchParams(search).get('tab');
        const { getFieldDecorator } = this.props.form;
        const navButtons = <div><Button type={"link"} icon={"arrow-left"} onClick={this.onClickLeftArrow} /> <Button type={"link"} icon={"arrow-right"} onClick={this.onClickRighttArrow} /></div>
        return <div>
            {this.projectsStore.state.item && <Row gutter={0}>
                <Col span={16}>
                    <ContentTitle type={t("Project")} title={this.projectsStore.state.item.title} />
                </Col>
                <Col span={8}>
                </Col>
            </Row>}
            <Row type={'flex'} align='top' justify='space-between'>
                {this.projectsStore.state.result && !this.projectsStore.state.result.isSuccess && (
                    <Alert
                        type="error"
                        message={t("An error has occurred")}
                        description={formatMessage(this.projectsStore.state.result)}
                    />
                )}
                <Card style={{ width: '100%' }}>
                    <Tabs
                        tabBarExtraContent={navButtons}
                        onChange={this.onChange}
                        activeKey={this.isTabAvilable(tabId) ? tabId as any : this.state.activeKey}
                        defaultActiveKey={this.isTabAvilable(tabId) ? tabId as any : 'general'}
                    >
                        <Tabs.TabPane key="general" tab={t("Project")}>
                            <FormEditorView
                                onSaveItem={this.handleUpdateItem}
                                form={this.props.form}
                                style={{ maxWidth: 800}}>
                                <ProjectFormBody
                                    readOnly={isReadOnly}
                                    i18n={this.props.i18n} t={this.props.t} tReady={this.props.tReady}
                                    item={this.projectsStore.state.item}
                                    getFieldDecorator={getFieldDecorator}
                                />
                            </FormEditorView>
                        </Tabs.TabPane>
                        <Tabs.TabPane key="members" tab={t("Members")}>
                            <ProjectsMembersList
                                onRefreshRequired={() => this.setState({ shouldRefreshAssignments: true })}
                                projectName={this.projectsStore.state.item?.title} />
                        </Tabs.TabPane>
                        <Tabs.TabPane key="tasks" tab={t("Tasks")}>
                            <ProjectsTasksList
                                onRefreshRequired={() => {
                                    this.setState({ shouldRefreshAssignments: true })
                                }}
                                refresh={this.state.shouldRefreshTasks}
                                onRefresh={() => this.setState({ shouldRefreshTasks: false })}
                                companyAllowCir={this.projectsStore.state.item?.allowedCir}
                                companyAllowCii={this.projectsStore.state.item?.allowedCii}
                            />
                        </Tabs.TabPane>
                        <Tabs.TabPane key="assignments" tab={t("Assignments")}>
                            <ProjectsTasksAssignmentsList
                                refresh={this.state.shouldRefreshAssignments}
                                onRefresh={() => this.setState({ shouldRefreshAssignments: false })}
                                projectName={this.projectsStore.state.item?.title} />
                        </Tabs.TabPane>
                    </Tabs>
                </Card>
            </Row>
        </div>
    }
}

// Wire up the React component to the Redux store
export default withUserProfile(withCache(withIdentity(withRouter(withTranslation()(Form.create({})(ProjectView) as any) as any)) as any)) as any as React.ComponentClass<ProjectViewProps>;
